import { graphql } from 'src/gql';

export const RESEND_ADVISOR_ONBOARDING_MUTATION = graphql(/* GraphQL */ `
  mutation ResendAdvisorOnboarding($stagedHouseholdId: ID!, $clientOnboardingRequestIds: [ID!]) {
    resendAdvisorOnboarding(
      input: { stagedHouseholdId: $stagedHouseholdId, clientOnboardingRequestIds: $clientOnboardingRequestIds }
    ) {
      success
      errors {
        field
        message
      }
      resentTo {
        id
        name
        email
      }
      skipped {
        id
        name
        email
      }
      stagedHousehold {
        id
        status
      }
    }
  }
`);

export const SEND_ADVISOR_ONBOARDING_INVITE_TO_OPS_MUTATION = graphql(/* GraphQL */ `
  mutation SendAdvisorOnboardingInviteToOps($householdPublicId: ID!) {
    sendAdvisorOnboardingInviteToOps(input: { householdPublicId: $householdPublicId }) {
      success
      errors {
        field
        message
      }
    }
  }
`);
